import styled, { css } from 'styled-components';
import { colors } from '@alixpartners/ui-components';

export const Wrapper = styled.div`
	display: flex;
	flex-direction: column;
	height: 100%;
	background-color: ${colors.white};
	transition: width 0.2s linear;
	width: 100%;
	position: relative;
	overflow: hidden;

	${({ isCollapsed }) =>
		isCollapsed &&
		css`
			width: 0%;
			min-width: 48px;
			box-shadow: inset 1px 0px 0px ${colors.grey3};
		`};

	${({ isCollapsed, align }) => {
		if (!isCollapsed) {
			return;
		}

		return `box-shadow: inset ${align === 'right' ? '' : '-'}1px 0px 0px ${
			colors.grey3
		};`;
	}};
`;

export const IconWrapper = styled.div`
	position: absolute;
	cursor: pointer;
	top: 6px;
	right: 6px;

	${({ align }) => align === 'left' && 'transform: rotate(180deg);'};
`;

export const CollapsedRow = styled.div`
	display: flex;
	flex-direction: column;
	height: 100%;
	align-items: center;
	padding: 6px 0;
`;

export const CollapsedIconWrapper = styled.div`
	${({ align }) =>
		align === 'right' &&
		css`
			transform: rotate(180deg);
		`};
`;

export const CollapsedColumn = styled.div`
	height: 100%;
	display: flex;
	padding: 10px 0;
	overflow: hidden;
`;

export const Title = styled.div`
	white-space: nowrap;
	writing-mode: vertical-lr;
	text-align: right;
	transform: rotate(-180deg);
	overflow: hidden;
	text-overflow: ellipsis;
`;

export const Description = styled(Title)`
	font-size: 13px;
	color: ${colors.grey5};
	letter-spacing: 0.3px;
	text-align: left;
`;
